module.exports = __webpack_public_path__ + "img/IMG_9033_L_Foamcore.fd4bc7ac.jpg";